module.exports = __webpack_public_path__ + "img/dqxqLb_banner.1949c29.png";